export default "__VITE_ASSET__NM7vdPdA__"